"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFieldName = void 0;
var AddressFieldName;
(function (AddressFieldName) {
    AddressFieldName["ADDRESS"] = "address";
    AddressFieldName["ADDRESS_LINE_2"] = "addressLine2";
    AddressFieldName["ADDRESS_LINE_3"] = "addressLine3";
    AddressFieldName["ADDRESS_LINE_4"] = "addressLine4";
    AddressFieldName["CITY"] = "city";
    AddressFieldName["CITY_FRENCH"] = "cityFrench";
    AddressFieldName["CUSTOM_TOWN"] = "customTown";
    AddressFieldName["COUNTRY"] = "country";
    AddressFieldName["COUNTY"] = "county";
    AddressFieldName["HOUSE_NUMBER"] = "houseNumber";
    AddressFieldName["HOUSE_NUMBER_ADDITION"] = "houseNumberAddition";
    AddressFieldName["POSTCODE"] = "postCode";
    AddressFieldName["ZIP_CODE"] = "zipCode";
    AddressFieldName["STATE"] = "state";
    AddressFieldName["STATE_ISO"] = "stateIso";
    AddressFieldName["FINDER"] = "finder";
})(AddressFieldName || (exports.AddressFieldName = AddressFieldName = {}));
//# sourceMappingURL=AddressEnums.js.map